import type { TransactionStore } from "./types";

const STATE_KEY = "pfdn.oauth.state";
const RETURN_KEY = "pfdn.oauth.return";

export function createTransactionStore(): TransactionStore {
  return {
    getState: () => sessionStorage.getItem(STATE_KEY),
    setState: (state) => sessionStorage.setItem(STATE_KEY, state),
    clear: () => sessionStorage.removeItem(STATE_KEY),
    getReturnTo: () => sessionStorage.getItem(RETURN_KEY),
    setReturnTo: (url) => sessionStorage.setItem(RETURN_KEY, url),
    clearReturnTo: () => sessionStorage.removeItem(RETURN_KEY),
  };
}
